module.exports = __webpack_public_path__ + "static/img/s32.391a50a3.png";